import React, { useEffect } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  HOME_URL,
  STUDENT_HOME_URL,
  STUDENT_ROLE,
  TEACHER_JOURNEY_URL,
  TEACHER_ROLE,
} from "../constants";
import StudentHeader from "../components/studentHeader";
import TeacherHeader from "../components/teacherHeader";
const Layout = ({ children }) => {
  const currentUser = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();

  useEffect(() => {
    // if (!currentUser?.id) {
    //   navigate(HOME_URL);
    // }
    // if (currentUser?.role === STUDENT_ROLE) {
    //   navigate(STUDENT_HOME_URL);
    // }
    // if (currentUser?.role === TEACHER_ROLE) {
    //   navigate(TEACHER_JOURNEY_URL);
    // }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);
  return (
    <div>
      {currentUser?.role === STUDENT_ROLE ? <StudentHeader /> : ""}
      {currentUser?.role === TEACHER_ROLE ? <TeacherHeader /> : ""}
      {!currentUser?.id ? <Header /> : ""}

      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
